import { combineReducers } from 'redux';

/* Reducers */
import login from './login/';
import resetPassword from './resetPassword/';
import confirmAccount from './confirmAccount/';
import dashboard from './dashboard/';
import userAdmin from './userAdmin/';
import calculationUnitAdmin from './calculationUnitAdmin/';
import groupAdmin from './groupAdmin/';
import assignGroupAdmin from './assignGroupAdmin/';
import assignPolynomialGroupAdmin from './assignPolynomialGroupAdmin/';
import assignPolynomialCalculationUnitAdmin from './assignPolynomialCalculationUnitAdmin/';
import dimensionAdmin from './dimensionAdmin/';
import metricAdmin from './metricAdmin/';
import virtualMetricAdmin from './virtualMetricAdmin';
import metricsGroupAdmin from './metricsGroupAdmin/';
import metricDataAdmin from './metricDataAdmin/';
import polynomialAdmin from './polynomialAdmin/';
import endpointsConnectorsAdmin from './endpointsConnectorsAdmin';
import endpointsConnectorsPanel from './endpointsConnectorsPanel';
import periodAdmin from './periodAdmin/';
import closedPeriodsAdmin from './closedPeriodsAdmin/';
import calculationsHistory from './calculationsHistory/';
import preCalculationsHistory from './preCalculationsHistory/';
import reportTemplateAdmin from './reportTemplateAdmin/';
import assignReportTemplateGroupAdmin from './assignReportTemplateGroupAdmin/';
import assignReportTemplateCalculationUnitAdmin from './assignReportTemplateCalculationUnitAdmin/';
import reportFileAdmin from './reportFileAdmin/';
import biTemplateAdmin from './biTemplateAdmin/';
import formulaEditor from './formulaEditor/';
import tableEditor from './tableEditor/';
import entityUseQuery from './entityUseQuery/';
import calendarAdmin from './calendarAdmin/';
import home from './home/';
import biCalculationsSummary from './biCalculationsSummary/';
import endpointsConnectorsVariablesAdmin from './endpointsConnectorsVariablesAdmin';
import supervisorsAdminRevisionPanel from './supervisorsAdminRevisionPanel';
import supervisorRevisionPanel from './supervisorRevisionPanel';
import exportConfigurationsAdmin from './exportConfigurationsAdmin';

const reducer = combineReducers({
  login,
  resetPassword,
  confirmAccount,
  dashboard,
  userAdmin,
  calculationUnitAdmin,
  groupAdmin,
  assignGroupAdmin,
  assignPolynomialGroupAdmin,
  assignPolynomialCalculationUnitAdmin,
  dimensionAdmin,
  metricAdmin,
  virtualMetricAdmin,
  metricsGroupAdmin,
  metricDataAdmin,
  polynomialAdmin,
  endpointsConnectorsAdmin,
  endpointsConnectorsPanel,
  endpointsConnectorsVariablesAdmin,
  periodAdmin,
  closedPeriodsAdmin,
  calculationsHistory,
  preCalculationsHistory,
  reportTemplateAdmin,
  assignReportTemplateGroupAdmin,
  assignReportTemplateCalculationUnitAdmin,
  reportFileAdmin,
  biTemplateAdmin,
  formulaEditor,
  tableEditor,
  entityUseQuery,
  calendarAdmin,
  biCalculationsSummary,
  supervisorsAdminRevisionPanel,
  supervisorRevisionPanel,
  exportConfigurationsAdmin,
  home,
});

export default reducer;



// WEBPACK FOOTER //
// ./source/client/reducers/index.js